import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  settlementAccountText: 'Make this my Settlement Account',
  warning:
    'Your existing Settlement Account {settlementAccount} will be replaced.',
})
